import { Location } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { DEEPLINK_STORAGE_KEY, OVERVIEW_ROUTE } from '@rci/self-serve-fido/app.constant';
import { SESSION_STORAGE } from '@rci/storage/session-storage.service';

@Injectable({ providedIn: 'root' })
export class DeeplinkService {
  private deepLinkUrl: string;

  constructor(
    @Inject(SESSION_STORAGE) private readonly sessionStorage: Storage,
    private readonly location: Location,
    private readonly router: Router,
  ) {}

  processDeeplink() {
    if (!this.deepLinkUrl) {
      this.router.navigate([OVERVIEW_ROUTE]);
    }

    this.router.navigateByUrl(this.deepLinkUrl);
    this.deepLinkUrl = '';
  }

  storeDeeplinkState(state: RouterStateSnapshot) {
    this.deepLinkUrl = state.url;
    this.sessionStorage.setItem(DEEPLINK_STORAGE_KEY, this.location.prepareExternalUrl(state.url));
  }
}
